import upp from 'app/app.module';

export class IosInstallationPromptComponent {
    static $inject = [ '$scope' ];
    constructor($scope) {
        Object.defineProperties(this, {
            appName: { get: () => $scope['appName'] },
            logoUrl: { get: () => $scope['logoUrl'] },
            onClose: { get: () => $scope['onClose'] },
        });
    }
}

upp.directive('iosInstallationPrompt', function() {
    return {
        restrict: 'E',
        scope: {
            appName: '@',
            logoUrl: '@',
            onClose: '&',
        },
        templateUrl: require('./ios-installation-prompt.component.html'),
        styles: require('./ios-installation-prompt.component.less'),
        controllerAs: '$ctrl',
        controller: IosInstallationPromptComponent,
    };
});



// WEBPACK FOOTER //
// ./src/app/common/components/installation-prompt/ios-installation-prompt/ios-installation-prompt.component.js